import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ConfigProvider } from 'components/ui'
import useDarkMode from 'utils/hooks/useDarkMode'
import { themeConfig } from 'configs/theme.config'
import { setUser } from 'store/auth/userSlice'
import { setCompany } from 'store/auth/companySlice'
import axios from 'axios'
import { onSignInSuccess } from 'store/auth/sessionSlice'

const Theme = (props) => {
    const dispatch = useDispatch()
    const handleTokenFromURL = async () => {
        // Check if there's a token in the URL parameters
        const urlParams = new URLSearchParams(window.location.search)
        const newToken = urlParams.get('Token')

        if (newToken) {
            dispatch(onSignInSuccess(newToken))
            const headers = {
                'x-order-token': newToken,
            }

            try {
                const result = await axios.get(
                    `${process.env.REACT_APP_API_URL}/api/user/viewProfile`,
                    { headers }
                )
                // console.log('result', result.data)
                if (result.data.data) {
                    await dispatch(setUser(result.data.data))
                    await dispatch(setCompany(result.data.company))
                }
            } catch (error) {
                console.error('Error fetching user profile:', error)
            }
        }
    }

    useEffect(() => {
        handleTokenFromURL()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.location.search])
    const theme = useSelector((state) => state.theme)
    const locale = useSelector((state) => state.locale.currentLang)
    const [isDark] = useDarkMode()

    const currentTheme = {
        mode: isDark ? 'dark' : 'light',
        ...themeConfig,
        ...theme,
        ...{ locale },
    }

    return (
        <ConfigProvider value={currentTheme}>{props.children}</ConfigProvider>
    )
}

export default Theme
